import {IsNotEmpty, ValidationOptions} from 'class-validator';

export function MyIsNotEmpty(validationOptions: ValidationOptions = {}) {
  const options = Object.assign({message: 'This field should not be empty'}, validationOptions);
  return IsNotEmpty(options);
}
